import React from "react";
import { History } from "lucide-react";
import { TspCard } from "../../../components/primitives";

export default function RouteHistoryCard({ history }) {
  return (
    <TspCard title="Route History">
      {history.length === 0 ? (
        <p className="tsp-muted-text">No route changes recorded yet.</p>
      ) : (
        <ul className="tsp-route-history-list">
          {history.map((entry) => (
            <li key={entry.id}>
              <History size={13} className="tsp-route-history-icon" />
              <span className="tsp-route-history-body">
                <span className="tsp-route-history-summary">{entry.summary}</span>
                <span className="tsp-route-history-meta">
                  {entry.updatedBy} · {entry.updatedAt}
                </span>
              </span>
            </li>
          ))}
        </ul>
      )}
    </TspCard>
  );
}
